import React from 'react';
import BillingField from './BillingField';
import { IBillingValues, SelectItem } from '../types/locationTypes';
import CommonRow from './CommonRow';
import { useStylesForForms } from './billingHelpers';

interface BillingFormType2Props {
    billingValuesObj: IBillingValues,
    handleSetBillingValuesObj: any,
    disabled: boolean,
    retainerIntervals: SelectItem[],
}

const BillingFormType2: React.FC<BillingFormType2Props> = ({
    billingValuesObj,
    handleSetBillingValuesObj,
    disabled,
    retainerIntervals,
}) => {
    const classes = useStylesForForms();
    return (
        <>
            <div className={classes.flexContainer}>
                <div>
                    <hr className={classes.separator} />
                </div>
                <div className={classes.row}>
                    <BillingField
                        title="WEEKDAYS TRANSFERS 1 -3 ($)" 
                        description="Fee per transfer for the first three transfers on a week day."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.weekDayThreeTransferFees}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('weekDayThreeTransferFees', newValue)}
                    />
                    <BillingField
                        title="WEEKDAYS TRANSFERS 4+ ($)" 
                        description="Fee per transfer for the fourth (or more) transfer per week day."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.weekDayFourTransferFees}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('weekDayFourTransferFees', newValue)}
                    />
                    <BillingField
                        title="WEEKENDS TRANSFERS 1 -3 ($)" 
                        description="Fee per transfer for the first three transfers on a weekend."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.weekEndThreeTransferFees}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('weekEndThreeTransferFees', newValue)}
                    />
                    <BillingField
                        title="WEEKENDS TRANSFERS 4+ ($)" 
                        description="Fee per transfer for the fourth (or more) transfers on a weekend."
                        parentClasses={classes}
                        disabled={disabled}
                        value={billingValuesObj.weekEndFourTransferFees}
                        setValue={(newValue: string | null) => handleSetBillingValuesObj('weekEndFourTransferFees', newValue)}
                    />
                </div>
                <div>
                    <hr className={classes.separator} />
                </div>
                <CommonRow 
                    billingValuesObj={billingValuesObj}
                    handleSetBillingValuesObj={handleSetBillingValuesObj}
                    disabled={disabled}
                    parentClasses={classes}
                    retainerIntervals={retainerIntervals}
                />
            </div>

        </>
    );
}

export default BillingFormType2;